import slugify from "slugify";

export function projectSlug(project: { name: string; id: string }) {
  return `${slugify(project.name, {
    lower: true,
  })}-${project.id}`;
}
